import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import { api } from '../shared';
import * as types from './types';

export const cleanup = createAction(types.CLEANUP);
export const clearRdcOffset = createAction(types.CLEAR_RDC_OFFSET);
export const decreaseRdcOffset = createAction(types.DECREASE_RDC_OFFSET);
export const increaseRdcOffset = createAction(types.INCREASE_RDC_OFFSET);

export const getArchivedJobs = createApiAction(
  types.ARCHIVED_JOBS_GET,
  (payload) => api.getArchivedJobs(payload),
  { meta: { skipErrorPage: true } },
);

export const getArchivedRdcJobs = createApiAction(
  types.ARCHIVED_RDC_JOBS_GET,
  (payload) => api.getArchivedJobs(payload),
  { meta: { skipErrorPage: true } },
);

export const changePage = createAction(types.CHANGE_PAGE);
export const changePerPage = createAction(types.CHANGE_PER_PAGE);
export const resetPage = createAction(types.RESET_PAGE);
export const showLoader = createAction(types.SHOW_LOADER);
